<h3 class="firewall-service__title">Rule Name</h3>
<p>{{ name }}</p>
